import {useAppDispatch, useAppSelector} from '@/redux/reduxUtils';
import {setActiveTeamId as setActiveTeamIdAction} from '@/redux/slices/director';
import {useCallback} from 'react';

export const useGlobalActiveTeamState = () => {
  const dispatch = useAppDispatch();
  const globalActiveTeamId = useAppSelector((state) => state.directorReducer.activeTeamId);

  const setGlobalActiveTeamId = useCallback(
    (activeTeamId: string) => {
      dispatch(setActiveTeamIdAction(activeTeamId));
    },
    [dispatch]
  );

  return {setGlobalActiveTeamId, globalActiveTeamId};
};
